"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactNative = require("react-native");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var getRgba = function getRgba(rgb, opacity) {
  return "rgba(".concat(rgb[0] || 0, ", ").concat(rgb[1] || 0, ", ").concat(rgb[2] || 0, ", ").concat(opacity, ")");
};

var _default = function _default(_ref) {
  var style = _ref.style,
      _ref$colorRgb = _ref.colorRgb,
      colorRgb = _ref$colorRgb === void 0 ? [0, 0, 0] : _ref$colorRgb,
      _ref$reverse = _ref.reverse,
      reverse = _ref$reverse === void 0 ? false : _ref$reverse,
      children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: style
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      background: "linear-gradient(".concat(reverse ? '360deg' : '180deg', ", ").concat(getRgba(colorRgb, 1), " 0%, ").concat(getRgba(colorRgb, 0.5), " 50%, transparent 100%)"),
      width: '100%',
      height: '100%'
    }
  }, children));
};

exports["default"] = _default;